import React, { Component } from "react";
import Button from "@material-ui/core/Button";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import { Link } from "react-router-dom";
import Grid from "@material-ui/core/Grid";
import Typography from "@material-ui/core/Typography";
import Container from "@material-ui/core/Container";
import { withStyles } from "@material-ui/core";
import { Cookies } from "react-cookie";
import { Alert, AlertTitle } from "@material-ui/lab";
import { Redirect } from "react-router-dom";
import Paper from "@material-ui/core/Paper";
import Table from "@material-ui/core/Table";
import TableBody from "@material-ui/core/TableBody";
import TableCell from "@material-ui/core/TableCell";
import TableContainer from "@material-ui/core/TableContainer";
import TableHead from "@material-ui/core/TableHead";
import TablePagination from "@material-ui/core/TablePagination";
import TableRow from "@material-ui/core/TableRow";
import JDate from "jalali-date";
import FloatingLabelInput from "./FloatingLabelInput";
import * as constants from "../constants";
import Divider from "@material-ui/core/Divider";
import TableSortLabel from "@material-ui/core/TableSortLabel";
import { Multiselect } from "multiselect-react-dropdown";
import Moment from "moment";
import NumberFormat from "react-number-format";
import HighlightOffIcon from "@material-ui/icons/HighlightOff";
import Select from "react-select";
import ImageUploader from "react-images-upload";
import LinearProgress from "@material-ui/core/LinearProgress";
import { $POST, $post } from "./../func";
import Switch from "@material-ui/core/Switch";
import Collapse from "@material-ui/core/Collapse";

import "react-modern-calendar-datepicker/lib/DatePicker.css";
import Calendar from "react-modern-calendar-datepicker";
import OutlinedInput from "@material-ui/core/OutlinedInput";
import IconButton from "@material-ui/core/IconButton";
import InputAdornment from "@material-ui/core/InputAdornment";
import ReactExport from "react-data-export";
import Avatar from "@material-ui/core/Avatar";
import { Lightbox } from "react-modal-image";
import Box from "@material-ui/core/Box";
import KeyboardArrowDownIcon from "@material-ui/icons/KeyboardArrowDown";
import KeyboardArrowUpIcon from "@material-ui/icons/KeyboardArrowUp";
import { makeStyles } from "@material-ui/core/styles";
import Checkbox from "@material-ui/core/Checkbox";
import Snackbar from "@material-ui/core/Snackbar";

import ReactHTMLTableToExcel from "react-html-table-to-excel";

const useRowStyles = makeStyles({
      root: {
            "& > *": {
                  borderBottom: "unset",
            },
      },
});

const styleselect = {
      multiselectContainer: {
            // To change css for multiselect (Width,height,etc..)
            fontSize: "14px",
            border: "1.25px solid #bababa",
            borderRadius: "4px",
      },
      searchBox: {
            // To change search box element look
            fontSize: "14px",
            minheight: "50px",
            textAlign: "right",
      },
      inputField: {
            // To change input field position or margin
            margin: "5px",
            fontSize: "14px",
      },
      chips: {
            // To change css chips(Selected options)
            //  background: '#00000000',
            border: "2px solid",
            fontSize: "14px",
      },
      optionContainer: {
            // To change css for option container
            textAlign: "right",
      },
      option: {
            // To change css for dropdown options
            fontSize: "14px",
            textAlign: "right",
      },
      groupHeading: {
            // To chanage group heading style
      },
};
const styles = (theme) => ({
      btnsearch: {
            [theme.breakpoints.up("md")]: {
                  width: "120px",
                  height: "40px",
                  fontSize: "15px",
            },
            width: "80px",
            height: "30px",
            fontSize: "13px",
            color: "white",
            backgroundColor: "#41589f",
            //  marginRight:'200px',
            //  marginLeft:'200px',
            marginTop: "30px",
            marginBottom: "10px",
            borderRadius: "4px",
            border: "1px solid #41589f",
      },

      paperrtl: {
            marginTop: theme.spacing(0),
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
      },
      paper: {
            display: "flex",
            flexWrap: "wrap",
            "& > *": {
                  margin: theme.spacing(1),
                  width: theme.spacing(20),
            },
      },
      root: {
            width: "100%",
            margin: "15px",
            padding: "8px",
            direction: "rtl",
      },
      container: {
            maxHeight: 400,
      },
      select: {
            searchBox: {
                  // To change search box element look
                  border: "none",
                  fontSize: "35px",
                  minheight: "50px",
            },
            inputField: {
                  // To change input field position or margin
                  margin: "5px",
            },
            chips: {
                  // To change css chips(Selected options)
                  background: "red",
            },
            optionContainer: {
                  // To change css for option container
                  border: "2px solid",
            },
            option: {
                  // To change css for dropdown options
                  color: "blue",
            },
      },
});

class ChangeReportReferralRequest extends Component {
      cookies = new Cookies();

      constructor(props) {
            super(props);
            this.state = {
                  search: false,
                  redirect: false,
                  requestinfos: [],
                  requestinfofilter: [],
                  rowsPerPage: 10,
                  page: 0,
                  showPaperDetail: false,
                  archiveDetail: [],
                  orderBy: "request_id",
                  order: "desc",
                  options: [],
                  optionFieldInsurance: [],
                  optionCompany: [{ value: "0", label: "همه شرکت های بیمه" }],
                  optionCity: [{ value: "0", label: "همه شهرها" }],
                  optionState: [{ value: "0", label: "همه استانها" }],
                  selectedFieldInsurance: [],
                  selectedCity: { value: "0", label: "همه شهرها" },
                  selectedState: { value: "0", label: "همه استانها" },
                  optionAgent: [{ value: "0", label: "همه نماینده های بیمه" }],
                  selectedAgent: { value: "0", label: "همه نماینده های بیمه" },

                  selectedComoany: { value: "0", label: "همه شرکت های بیمه" },
                  selectedDayEnd: "",
                  selectedDayStart: "",
                  dataChart: [],
                  mobileMarketerFilter: "",
                  mobileLeaderFilter: "",
                  mobileUsertFilter: "",
                  requestIdFilter: "",
                  urlToLargeImageFile: "",
                  urlToHugeImageFile: "",
                  descImageFile: "",
                  openImageBox: false,
                  snackstr: "",
                  showSnack: false,
                  snackMode: "success",

                  sumPeyCommision: 0,
                  sumPeyCommisionMarketer: 0,
                  sumPeyCommisionLeader: 0,
                  sumPeyCommisionUser: 0,
                  sumPayIns: 0,
                  sumCommission: 0,
                  reagent_mobile: "",
            };
      }

      // ----------------------------------------------------------------------------------------------------
      async componentDidMount() {
            if (this.cookies.get("employee_token_str")) {
                  this.props.props.props.dispatch({
                        type: "WAITSHOW",
                  });

                  var self = this;
                  const response = await $POST("employeelogin?command=checkemployeelogin");
                  const arr = response.data;
                  if (response.status == 200) {
                        if (arr.result === "ok") {
                              self.getOrder();
                        } else if (arr.result === "error") {
                              self.setState({ redirect: true });
                        }
                        self.props.props.props.dispatch({
                              type: "WITEHIDE",
                        });
                  }
            } else {
                  this.setState({ redirect: true });
            }
      }

      // -----------------------------------------------------------------------------------------------------------------
      async getOrder() {
            const { rowsPerPage, page } = this.state;
            this.props.props.props.dispatch({
                  type: "WAITSHOW",
            });
            var self = this;
            const response = await $POST(
                `reportreferral?com2mand=get_request_detail&limit=${rowsPerPage}&offset=${
                    page * rowsPerPage
                }`
            );
            const arr = response.data;
            if (response.status == 200) {
                  if (arr.result === "ok") {
                        self.setState(
                            {
                                  requestinfos: arr.data,
                                  requestinfofilter: arr.data,
                                  arrCount: arr.cnt,
                            },
                            () => {
                                  // self.filterList();
                                  self.getFieldInsurance();

                                  self.getoptionStateID();
                                  self.getoptionCompany();
                                  self.getoptionAgent();

                                  self.hidePaperDetail();
                            }
                        );
                  } else if (arr.result === "error") {
                  }
                  self.props.props.props.dispatch({
                        type: "WITEHIDE",
                  });
            }
      }

      // -------------------------------------------------------------------------------------------------------------------------------
      async getFieldInsurance() {
            //     post
            this.props.props.props.dispatch({
                  type: "WAITSHOW",
            });
            var self = this;
            const response = await $POST("financialpaying?command=get_fieldinsurance");
            const arr = response.data;
            if (response.status == 200) {
                  if (arr.result === "ok") {
                        var i,
                            temp,
                            temparray = [];

                        self.setState({ optionFieldInsurance: arr.data }, () => {});
                  } else if (arr.result === "error") {
                  }
                  self.props.props.props.dispatch({
                        type: "WITEHIDE",
                  });
            }
      }
      // ---------------------------------------------------------------------------------------------------
      getoptionCompany = async () => {
            var self = this;
            const response = await $POST("company?command=get_company");
            const arr = response.data;
            if (response.status == 200) {
                  if (arr.result === "ok") {
                        var Comoany = [{ value: "0", label: "همه شرکت های بیمه" }];
                        for (var k = 0; k < arr.data.length; k++) {
                              Comoany.push({
                                    value: arr.data[k].company_id,
                                    label: arr.data[k].company_name,
                                    logo: arr.data[k].company_logo_url,
                              });
                        }
                        self.setState(
                            { optionComoany: Comoany, selectedComoany: Comoany[0] },
                            () => {}
                        );
                  } else if (arr.result === "error") {
                        self.setState({
                              snackstr: arr.desc,
                              showSnack: true,
                              snackMode: "error",
                        });
                  }
            }
      };

      // ------------------------------------------------------------------------------------------------------------
      getoptionStateID = async () => {
            // post
            var self = this;
            const response = await $POST("statecity?command=get_state");
            const arr = response.data;

            if (response.status == 200) {
                  if (arr.result === "ok") {
                        var State = [{ value: "0", label: "همه استانها" }];

                        for (var k = 0; k < arr.data.length; k++) {
                              State.push({
                                    value: arr.data[k].state_id,
                                    label: arr.data[k].state_name,
                              });
                        }
                        self.setState({ optionState: State, selectedState: State[0] }, () => {
                              self.getoptionCityID();
                        });
                  } else if (arr.result === "error") {
                        self.setState({
                              snackstr: arr.desc,
                              showSnack: true,
                              snackMode: "error",
                        });
                  }
            }
      };

      // ----------------------------------------------------------------------------------------------------
      getoptionCityID = async () => {
            // post
            var self = this;
            const response = await $POST(
                `statecity?command=get_city&state_id=${this.state.selectedState.value}`
            );
            const arr = response.data;
            if (response.status == 200) {
                  if (arr.result === "ok") {
                        var State = [];
                        for (var k = 0; k < arr.data.length; k++) {
                              State.push({
                                    value: arr.data[k].city_id,
                                    label: arr.data[k].city_name,
                              });
                        }
                        self.setState({ optionCity: State });
                  } else if (arr.result === "error") {
                        self.setState({
                              snackstr: arr.desc,
                              showSnack: true,
                              snackMode: "error",
                        });
                  }
            }
      };

      getoptionAgent = () => {
            const { selectedCity, selectedState, selectedComoany } = this.state;
            var self = this;
            var xhttp = new XMLHttpRequest();
            xhttp.onreadystatechange = function () {
                  if (this.readyState === 4 && this.status === 200) {
                        var arr = JSON.parse(this.responseText);
                        if (arr.result === "ok") {
                              var State = [{ value: "0", label: "همه نماینده های بیمه" }];
                              for (var k = 0; k < arr.data.length; k++) {
                                    State.push({
                                          value: arr.data[k].agent_id,
                                          label:
                                              arr.data[k].agent_name +
                                              " " +
                                              arr.data[k].agent_family +
                                              "-" +
                                              arr.data[k].agent_mobile,
                                          agent_status: arr.data[k].agent_status,
                                          company_id: arr.data[k].company_id,
                                    });
                              }
                              self.setState({
                                    optionAgent: State,
                                    selectedAgent: { value: "0", label: "همه نماینده های بیمه" },
                              });
                        } else if (arr.result === "error") {
                              self.setState({
                                    snackstr: arr.desc,
                                    showSnack: true,
                                    snackMode: "error",
                              });
                        }
                  }
            };

            var fd = new FormData();
            fd.append("command", "get_agent");
            if (selectedState.value !== "0") {
                  fd.append("agent_state_id", selectedState.value);
            } //
            if (selectedCity.value !== "0") {
                  fd.append("agent_city_id", selectedCity.value);
            } //
            if (selectedComoany.value !== "0") {
                  fd.append("agent_company_id", selectedComoany.value);
            } //


            xhttp.open("POST", `${constants.BASE_URL}/agent`);
            xhttp.setRequestHeader(
                "Authorization",
                this.cookies.get("employee_token_str")
            );
            xhttp.send(fd);
      };

      handleChangeReagentMobile = (event) => {
            this.setState({ reagent_mobile: event }, () => {});
      };

      // --------------------------------------------------------------------------------------------------------
      checkRagentMobile = async (mode, request_id) => {
            // post
            const { reagent_mobile } = this.state;

            if (reagent_mobile && reagent_mobile !== "") {
                  if (reagent_mobile.match(/09-?[0-9]{2}-?[0-9]{3}-?[0-9]{4}/)) {
                        var self = this;
                        const response = await $POST(
                            `userreferral?command=check_referral_mobile&user_refferal_name=${reagent_mobile}`
                        );
                        const arr = response.data;
                        if (response.status == 200) {
                              if (arr.result === "ok") {
                                    if (arr.data.length === 0) {
                                          self.setState({
                                                snackstr: "همراه معرف موجود نیست",
                                                showSnack: true,
                                                snackMode: "error",
                                          });
                                    } else {
                                          self.setState({
                                                snackstr: "همراه معرف موجود است",
                                                showSnack: true,
                                                snackMode: "success",
                                          });
                                          if (mode == 1) {
                                                self.changeRagentMobile(request_id);
                                          }
                                    }
                              } else if (arr.result === "error") {
                                    self.setState({
                                          snackstr: arr.desc,
                                          showSnack: true,
                                          snackMode: "error",
                                    });
                              }
                        }
                  } else {
                        this.setState({
                              snackstr: " شماره همراه را به درستی وارد نمایید",
                              showSnack: true,
                              snackMode: "error",
                        });
                  }
            } else {
                  this.setState({
                        snackstr: " شماره همراه را وارد نمایید",
                        showSnack: true,
                        snackMode: "error",
                  });
            }
      };
      // ---------------------------------------------------------------------------------------------------------

      changeRagentMobile = async (request_id) => {
            const { reagent_mobile } = this.state;

            if (reagent_mobile && reagent_mobile !== "") {
                  if (reagent_mobile.match(/09-?[0-9]{2}-?[0-9]{3}-?[0-9]{4}/)) {
                        var self = this;
                        const response = await $POST(
                            `reportreferral2?command=change_referral_mobile&reagent_mobile=${reagent_mobile}&request_id=${request_id}`
                        );
                        const arr = response.data;
                        if (response.status == 200) {
                              if (arr.result === "ok") {
                                    self.setState({
                                          snackstr: arr.desc,
                                          showSnack: true,
                                          snackMode: "success",
                                    });
                                    self.getOrder();
                              } else if (arr.result === "error") {
                                    self.setState({
                                          snackstr: arr.desc,
                                          showSnack: true,
                                          snackMode: "error",
                                    });
                              }
                        }
                  } else {
                        this.setState({
                              snackstr: " شماره همراه را به درستی وارد نمایید",
                              showSnack: true,
                              snackMode: "error",
                        });
                  }
            } else {
                  this.setState({
                        snackstr: " شماره همراه را وارد نمایید",
                        showSnack: true,
                        snackMode: "error",
                  });
            }
      };

      setImageModel = (image, largimage, desc) => {
            this.setState({
                  urlToLargeImageFile: largimage,
                  urlToHugeImageFile: image,
                  descImageFile: desc,
                  openImageBox: true,
            });
      };
      closeLightbox = () => {
            this.setState({
                  openImageBox: false,
            });
      };

      createSortHandler = (field) => {
            if (this.state.orderBy === field) {
                  if (this.state.order === "asc") {
                        this.setState({ order: "desc" });
                  } else {
                        this.setState({ order: "asc" });
                  }
            } else {
                  this.setState({ orderBy: field, order: "asc" });
            }
            var arraytemp = [],
                i,
                j,
                temp,
                a,
                b;
            arraytemp = this.state.requestinfofilter;
            for (i = 0; i < arraytemp.length; i++) {
                  for (j = 0; j < arraytemp.length - 1; j++) {
                        a = arraytemp[j];
                        b = arraytemp[j + 1];
                        if (a[field] < b[field] && this.state.order === "asc") {
                              temp = arraytemp[j];
                              arraytemp[j] = arraytemp[j + 1];
                              arraytemp[j + 1] = temp;
                        } else if (a[field] > b[field] && this.state.order === "desc") {
                              temp = arraytemp[j];
                              arraytemp[j] = arraytemp[j + 1];
                              arraytemp[j + 1] = temp;
                        }
                  }
            }
      };
      handleChangeRowsPerPage = (event) => {
            if (this.state.search) {
                  this.setState({ rowsPerPage: parseInt(event.target.value), page: 0 });

                  this.filterList();
            } else {
                  this.setState(
                      { rowsPerPage: parseInt(event.target.value), page: 0 },
                      () => {
                            this.getOrder();
                      }
                  );
            }
      };

      handleSelectRows = (request_id, row) => {
            this.setState({ showPaperDetail: true, archiveDetail: row });
      };

      hidePaperDetail = (event) => {
            this.setState({ showPaperDetail: false });
      };

      onSelectOptionFieldInsurance = (selectedList, selectedItem) => {
            this.setState(
                {
                      requestinfofilter: this.state.requestinfos,
                      selectedFieldInsurance: selectedList,
                },
                () => {}
            );
      };

      onRemoveOptionFieldInsurance = (selectedList, removedItem) => {
            this.setState(
                {
                      requestinfofilter: this.state.requestinfos,
                      selectedFieldInsurance: selectedList,
                },
                () => {}
            );
      };

      handleState = (selectedState) => {
            this.setState(
                {
                      selectedState: selectedState,
                      selectedCity: { value: "0", label: "همه شهرها" },
                },
                () => {
                      this.getoptionCityID();
                      this.getoptionAgent();
                }
            );
      };
      handleCity = (selectedCity) => {
            this.setState({ selectedCity: selectedCity }, () => {
                  this.getoptionAgent();
            });
      };
      handleAgent = (selectedAgent) => {
            this.setState({ selectedAgent: selectedAgent }, () => {});
      };

      handleCompany = (selectedComoany) => {
            this.setState({ selectedComoany: selectedComoany }, () => {
                  this.getoptionAgent();
            });
      };

      handleChangeFilterMobileLeader = (event) => {
            this.setState({ mobileLeaderFilter: event }, () => {});
      };

      handleChangeFilterMobileReagent = (event) => {
            this.setState({ mobileMarketerFilter: event }, () => {});
      };

      handleChangeFilterMobileUser = (event) => {
            this.setState({ mobileUsertFilter: event }, () => {});
      };
      handleChangeFilterRequestId = (event) => {
            this.setState({ requestIdFilter: event }, () => {});
      };
      // **********************************************************************************************************************
      // **********************************************************************************************************************
      // **********************************************************************************************************************
      convert = (x) => {
            return x.toString();
      };

      async filterList() {
            const { rowsPerPage, page } = this.state;
            this.setState({ search: true });
            const selectedFieldInsurance2 = [];
            if (this.state.selectedFieldInsurance.length > 0) {
                  for (let i = 0; i < this.state.selectedFieldInsurance.length; i++) {
                        selectedFieldInsurance2.push(
                            this.state.selectedFieldInsurance[i].fieldinsurance_id
                        );
                  }
            }
            var timeStampMax = parseInt(
                Moment(
                    JDate.toGregorian(
                        this.state.selectedDayEnd.year,
                        this.state.selectedDayEnd.month,
                        this.state.selectedDayEnd.day
                    )
                ).format("x"),
                0
            );
            var timeStampMin = parseInt(
                Moment(
                    JDate.toGregorian(
                        this.state.selectedDayStart.year,
                        this.state.selectedDayStart.month,
                        this.state.selectedDayStart.day
                    )
                ).format("x"),
                0
            );

            var maxdate = Moment(timeStampMax).format("YYYY-MM-DD");
            var mindate = Moment(timeStampMin).format("YYYY-MM-DD");
            //     ---------------------------------------------------------
            const response = await $POST(`reportreferral2?command=get_request
&request_id=${this.state.requestIdFilter}
&fieldinsurance_id=${this.convert(selectedFieldInsurance2)}
&agent_id=${this.state.selectedAgent.value}
&user_mobile=${this.state.mobileUsertFilter}
&peycommision_leader_mobile=${this.state.mobileMarketerFilter}
&peycommision_marketer_mobile=${this.state.mobileLeaderFilter}
&request_company_id=${this.state.selectedComoany.value}
&user_address_state_id=${this.state.selectedState.value}
&user_address_city_id=${this.state.selectedCity.value}
&start_requst_ready_timestamp=${mindate == "Invalid date" ? "" : mindate}
&end_requst_ready_timestamp=${maxdate == "Invalid date" ? "" : maxdate}
&limit=${rowsPerPage}&offset=${page * rowsPerPage}`);

            this.setState({
                  requestinfos: response.data.data,
                  requestinfofilter: response.data.data,
                  arrCount: response.data.cnt,
            });
      }



      feieldInsuranceExist = (fieldinsurance_id, selectedFieldInsurance) => {
            if (selectedFieldInsurance.length === 0) {
                  return true;
            } else {
                  for (var j = 0; j < selectedFieldInsurance.length; j++) {
                        if (fieldinsurance_id === selectedFieldInsurance[j].fieldinsurance_id) {
                              return true;
                        }
                  }
                  return false;
            }
      };

      handleChangePage = (event, number) => {
            this.setState({ page: parseInt(number, 0) }, () => {
                  this.getOrder();
            });
      };

      clearDeyEnd = (event) => {
            this.setState({ selectedDayEnd: "" }, () => {
            });
      };

      setSelectedDayEnd = (event) => {
            this.setState({ selectedDayEnd: event }, () => {
            });
      };

      clearDeyStart = (event) => {
            this.setState({ selectedDayStart: "" }, () => {
            });
      };

      setSelectedDayStart = (event) => {
            this.setState({ selectedDayStart: event }, () => {
            });
      };

      renderCustomInputEnd = ({ ref }) => (
          <OutlinedInput
              readOnly
              ref={ref} // necessary
              placeholder="انتخاب تاریخ پایان"
              value={
                    this.state.selectedDayEnd.year
                        ? this.state.selectedDayEnd.year +
                        "/" +
                        this.state.selectedDayEnd.month +
                        "/" +
                        this.state.selectedDayEnd.day
                        : ""
              }
              style={{
                    fontSize: "13px",
                    direction: "ltr",
              }}
              className="my-custom-input-class" // a styling class
              endAdornment={
                    <InputAdornment position="end">
                          <IconButton onClick={this.clearDeyEnd}>
                                <HighlightOffIcon />
                          </IconButton>
                    </InputAdornment>
              }
          />
      );

      renderCustomInputStart = ({ ref }) => (
          <OutlinedInput
              readOnly
              ref={ref} // necessary
              placeholder="انتخاب تاریخ شروع"
              style={{
                    fontSize: "13px",
                    direction: "ltr",
              }}
              value={
                    this.state.selectedDayStart.year
                        ? this.state.selectedDayStart.year +
                        "/" +
                        this.state.selectedDayStart.month +
                        "/" +
                        this.state.selectedDayStart.day
                        : ""
              }
              className="my-custom-input-class" // a styling class
              endAdornment={
                    <InputAdornment position="end">
                          <IconButton onClick={this.clearDeyStart}>
                                <HighlightOffIcon />
                          </IconButton>
                    </InputAdornment>
              }
          />
      );

      handleClickcloseTasckBar = (event) => {
            this.setState({ showSnack: false });
      };

      render() {
            const { classes } = this.props;
            const {
                  reagent_mobile,
                  sumPeyCommision,
                  sumPeyCommisionMarketer,
                  sumPeyCommisionLeader,
                  sumPeyCommisionUser,
                  sumPayIns,
                  sumCommission,
                  snackMode,
                  snackstr,
                  showSnack,
                  checkFinancialDocAll,
                  selectedComoany,
                  optionComoany,
                  selectedState,
                  selectedCity,
                  optionAgent,
                  selectedAgent,
                  optionCity,
                  optionState,
                  selectedDayEnd,
                  mobileLeaderFilter,
                  mobileMarketerFilter,
                  mobileUsertFilter,
                  requestIdFilter,
                  selectedDayStart,
                  order,
                  orderBy,
                  archiveDetail,
                  showPaperDetail,
                  redirect,
                  requestinfofilter,
                  rowsPerPage,
                  page,
                  arrCount,
                  urlToHugeImageFile,
                  descImageFile,
                  urlToLargeImageFile,
            } = this.state;
            var request_ready_image_tb = null;
            var request_ready_file_tb = null;
            var request_ready = null;
            var user_pey_detail = null;
            var user_pey_detail2 = null;
            var request_financial_approval = null;
            var request_financial_doc = null;

            if (archiveDetail["request_financial_approval"]) {
                  request_financial_approval =
                      archiveDetail["request_financial_approval"][0];
            }
            if (archiveDetail["request_financial_doc"]) {
                  request_financial_doc = archiveDetail["request_financial_doc"][0];
            }

            if (archiveDetail["request_ready"]) {
                  request_ready = archiveDetail["request_ready"][0];
                  if (request_ready) {
                        if (request_ready["request_ready_image_tb"]) {
                              request_ready_image_tb = request_ready["request_ready_image_tb"];
                        }
                        if (request_ready["request_ready_file_tb"]) {
                              request_ready_file_tb = request_ready["request_ready_file_tb"];
                        }
                  }
            }
            if (archiveDetail["user_pey_detail"]) {
                  user_pey_detail = archiveDetail["user_pey_detail"];
            }
            if (archiveDetail["user_pey_detail2"]) {
                  user_pey_detail2 = archiveDetail["user_pey_detail2"];
            }

            if (redirect) {
                  return <Redirect to="/" />;
            } else {
                  return (
                      <div className={classes.paperrtl} dir="ltr">
                            <Grid container spacing={3}>
                                  <Grid item xs={12}>
                                        <Container maxWidth="lg">
                                              <Paper
                                                  style={{ padding: "10px", direction: "rtl" }}
                                                  className={classes.root}
                                              >
                                                    <Grid container spacing={3}>
                                                          <Grid item xs={6}>
                                                                <div style={{ width: "100%", textAlign: "center" }}>
                                                                      <Typography variant="h7">
                                                                            {"تاریخ شروع بزرگتر از"}
                                                                            <Calendar
                                                                                renderInput={this.renderCustomInputStart} // render a custom input
                                                                                value={selectedDayStart}
                                                                                onChange={this.setSelectedDayStart}
                                                                                locale="fa"
                                                                                shouldHighlightWeekends
                                                                            />
                                                                      </Typography>
                                                                </div>
                                                          </Grid>
                                                          <Grid item xs={6}>
                                                                <div style={{ width: "100%", textAlign: "center" }}>
                                                                      <Typography variant="h7">
                                                                            {"تاریخ شروع کوچکتر از"}
                                                                            <Calendar
                                                                                renderInput={this.renderCustomInputEnd} // render a custom input
                                                                                value={selectedDayEnd}
                                                                                onChange={this.setSelectedDayEnd}
                                                                                locale="fa"
                                                                                shouldHighlightWeekends
                                                                            />
                                                                      </Typography>
                                                                </div>
                                                          </Grid>

                                                          <Grid item xs={12} sm={6}>
                                                                <div style={{ width: "100%", textAlign: "center" }}>
                                                                      <Multiselect
                                                                          style={styleselect}
                                                                          options={this.state.optionFieldInsurance} // Options to display in the dropdown
                                                                          selectedValues={
                                                                                this.state.selectedOptionFieldInsurance
                                                                          } // Preselected value to persist in dropdown
                                                                          onSelect={this.onSelectOptionFieldInsurance} // Function will trigger on select event
                                                                          onRemove={this.onRemoveOptionFieldInsurance} // Function will trigger on remove event
                                                                          displayValue="fieldinsurance_fa" // Property name to display in the dropdown options
                                                                          placeholder="انتخاب رشته"
                                                                          closeIcon="circle2"
                                                                          emptyRecordMsg="فیلد  در دسترس نیست "
                                                                      />
                                                                </div>
                                                          </Grid>

                                                          <Grid item xs={12} sm={6}>
                                                                <div>
                                                                      <label className="on">شرکت بیمه</label>
                                                                      <Select
                                                                          isSearchable={true}
                                                                          className="adapter-txtsize"
                                                                          placeholder={"شرکت بیمه"}
                                                                          value={selectedComoany}
                                                                          onChange={this.handleCompany}
                                                                          options={optionComoany}
                                                                      />
                                                                </div>
                                                          </Grid>

                                                          <Grid item xs={12} sm={4}>
                                                                <div>
                                                                      <label className="on">استان</label>
                                                                      <Select
                                                                          isSearchable={true}
                                                                          className="adapter-txtsize"
                                                                          placeholder={"استان"}
                                                                          value={selectedState}
                                                                          onChange={this.handleState}
                                                                          options={optionState}
                                                                      />
                                                                </div>
                                                          </Grid>

                                                          <Grid item xs={12} sm={4}>
                                                                <div>
                                                                      <label className="on">شهر</label>
                                                                      <Select
                                                                          isSearchable={true}
                                                                          className="adapter-txtsize"
                                                                          placeholder={"شهر"}
                                                                          value={selectedCity}
                                                                          onChange={this.handleCity}
                                                                          options={optionCity}
                                                                      />
                                                                </div>
                                                          </Grid>

                                                          <Grid item xs={12} sm={4}>
                                                                <div>
                                                                      <label className="on">نماینده</label>
                                                                      <Select
                                                                          isSearchable={true}
                                                                          className="adapter-txtsize"
                                                                          placeholder={"نماینده"}
                                                                          value={selectedAgent}
                                                                          onChange={this.handleAgent}
                                                                          options={optionAgent}
                                                                      />
                                                                </div>
                                                          </Grid>

                                                          <Grid item xs={12} sm={3}>
                                                                <FloatingLabelInput
                                                                    type="number"
                                                                    placeholder="همراه کاربر"
                                                                    value={mobileUsertFilter}
                                                                    handleInputt={this.handleChangeFilterMobileUser}
                                                                />
                                                          </Grid>

                                                          <Grid item xs={12} sm={3}>
                                                                <FloatingLabelInput
                                                                    type="number"
                                                                    placeholder="همراه همکار فروش"
                                                                    value={mobileMarketerFilter}
                                                                    handleInputt={this.handleChangeFilterMobileReagent}
                                                                />
                                                          </Grid>
                                                          <Grid item xs={12} sm={3}>
                                                                <FloatingLabelInput
                                                                    type="number"
                                                                    placeholder="همراه هماهنگ کننده فروش"
                                                                    value={mobileLeaderFilter}
                                                                    handleInputt={this.handleChangeFilterMobileLeader}
                                                                />
                                                          </Grid>

                                                          <Grid item xs={12} sm={3}>
                                                                <FloatingLabelInput
                                                                    type="number"
                                                                    placeholder="شماره سفارش"
                                                                    value={requestIdFilter}
                                                                    handleInputt={this.handleChangeFilterRequestId}
                                                                />
                                                          </Grid>
                                                    </Grid>
                                              </Paper>
                                              <div
                                                  style={{
                                                        width: "100%",
                                                        display: "flex",
                                                        justifyContent: "center",
                                                        alignItems: "center",
                                                  }}
                                              >
                                                    <button
                                                        onClick={() => this.filterList()}
                                                        className={classes.btnsearch}
                                                    >
                                                          جستجو
                                                    </button>
                                              </div>
                                        </Container>
                                  </Grid>

                                  <Grid item xs={12}></Grid>

                                  <Grid item xs={12}>
                                        <Collapse in={showPaperDetail}>
                                              <Container component="main" maxWidth="lg">
                                                    <Paper elevation={4} className={classes.root}>
                                                          <Grid container spacing={3}>
                                                                <Grid item xs={4}>
                                                                      <div style={{ width: "100%", textAlign: "right" }}>
                                                                            <Typography align="center" variant="h7">
                                                                                  {"شماره درخواست: " + archiveDetail["request_id"]}
                                                                            </Typography>
                                                                      </div>
                                                                </Grid>

                                                                <Grid item xs={8} sm={4}>
                                                                      <div style={{ width: "100%", textAlign: "center" }}>
                                                                            <Typography align="center" variant="h7">
                                                                                  {"رشته بیمه : " +
                                                                                  archiveDetail["request_fieldinsurance_fa"]}
                                                                                  <img
                                                                                      alt=""
                                                                                      style={{ height: "30px", width: "atuo" }}
                                                                                      src={archiveDetail["fieldinsurance_logo_url"]}
                                                                                  />
                                                                            </Typography>
                                                                      </div>
                                                                </Grid>

                                                                <Grid item xs={12} sm={4}>
                                                                      <div style={{ width: "100%", textAlign: "center" }}>
                                                                            <Typography align="center" variant="h7">
                                                                                  {"شرکت  : " + archiveDetail["company_name"]}
                                                                                  <img
                                                                                      alt=""
                                                                                      style={{ height: "30px", width: "atuo" }}
                                                                                      src={archiveDetail["company_logo_url"]}
                                                                                  />
                                                                            </Typography>
                                                                      </div>
                                                                </Grid>

                                                                <Grid item xs={12}>
                                                                      <Divider />
                                                                </Grid>

                                                                <Grid item xs={12}>
                                                                      <Grid container spacing={3}>
                                                                            <Grid item xs={12} sm={6}>
                                                                                  {request_ready_image_tb ? (
                                                                                      <TableContainer component={Paper}>
                                                                                            <Table
                                                                                                className={classes.table}
                                                                                                aria-label="simple table"
                                                                                            >
                                                                                                  <TableHead>
                                                                                                        <TableRow>
                                                                                                              <TableCell
                                                                                                                  style={{ minWidth: 60 }}
                                                                                                                  align="center"
                                                                                                              >
                                                                                                                    نام عکس
                                                                                                              </TableCell>
                                                                                                              <TableCell
                                                                                                                  style={{ minWidth: 100 }}
                                                                                                                  align="center"
                                                                                                              >
                                                                                                                    توضیحات
                                                                                                              </TableCell>
                                                                                                              <TableCell
                                                                                                                  style={{ minWidth: 30 }}
                                                                                                                  align="center"
                                                                                                              >
                                                                                                                    عکس{" "}
                                                                                                              </TableCell>
                                                                                                        </TableRow>
                                                                                                  </TableHead>
                                                                                                  <TableBody>
                                                                                                        {request_ready_image_tb.map((row) => {
                                                                                                              return (
                                                                                                                  <TableRow key={row.image_name}>
                                                                                                                        <TableCell align="center">
                                                                                                                              {" "}
                                                                                                                              {row.image_name}
                                                                                                                        </TableCell>
                                                                                                                        <TableCell align="center">
                                                                                                                              {row.image_desc}
                                                                                                                        </TableCell>

                                                                                                                        <TableCell align="center">
                                                                                                                              <div
                                                                                                                                  style={{
                                                                                                                                        width: "100%",
                                                                                                                                        textAlign: "center",
                                                                                                                                  }}
                                                                                                                              >
                                                                                                                                    <Avatar
                                                                                                                                        variant="rounded"
                                                                                                                                        alt="Remy Sharp"
                                                                                                                                        src={row.image_tumb_url}
                                                                                                                                        onClick={() => {
                                                                                                                                              this.setImageModel(
                                                                                                                                                  row.image_tumb_url,
                                                                                                                                                  row.image_url,
                                                                                                                                                  row.image_name
                                                                                                                                              );
                                                                                                                                        }}
                                                                                                                                    />
                                                                                                                              </div>
                                                                                                                        </TableCell>
                                                                                                                  </TableRow>
                                                                                                              );
                                                                                                        })}
                                                                                                  </TableBody>
                                                                                            </Table>
                                                                                      </TableContainer>
                                                                                  ) : null}
                                                                            </Grid>
                                                                            <Grid item xs={12} sm={6}>
                                                                                  {request_ready_file_tb ? (
                                                                                      <TableContainer component={Paper}>
                                                                                            <Table
                                                                                                className={classes.table}
                                                                                                aria-label="simple table"
                                                                                            >
                                                                                                  <TableHead>
                                                                                                        <TableRow>
                                                                                                              <TableCell
                                                                                                                  style={{ minWidth: 100 }}
                                                                                                                  align="center"
                                                                                                              >
                                                                                                                    توضیحات
                                                                                                              </TableCell>
                                                                                                              <TableCell
                                                                                                                  style={{ minWidth: 30 }}
                                                                                                                  align="center"
                                                                                                              >
                                                                                                                    لینک دانلود{" "}
                                                                                                              </TableCell>
                                                                                                        </TableRow>
                                                                                                  </TableHead>
                                                                                                  <TableBody>
                                                                                                        {request_ready_file_tb.map((row) => {
                                                                                                              return (
                                                                                                                  <TableRow key={row.request_file_desc}>
                                                                                                                        <TableCell align="center">
                                                                                                                              {" "}
                                                                                                                              {row.request_file_desc}
                                                                                                                        </TableCell>

                                                                                                                        <TableCell align="center">
                                                                                                                              <a href={row.request_file_url}>
                                                                                                                                    دانلود
                                                                                                                              </a>
                                                                                                                        </TableCell>
                                                                                                                  </TableRow>
                                                                                                              );
                                                                                                        })}
                                                                                                  </TableBody>
                                                                                            </Table>
                                                                                      </TableContainer>
                                                                                  ) : null}
                                                                            </Grid>
                                                                      </Grid>
                                                                </Grid>
                                                                <Grid item xs={12}>
                                                                      <Divider />
                                                                </Grid>

                                                                <Grid item xs={4}>
                                                                      <div style={{ width: "100%", textAlign: "right" }}>
                                                                            <Typography align="center" variant="h7">
                                                                                  {"مشخصات کاربر: " +
                                                                                  archiveDetail["user_name"] +
                                                                                  " " +
                                                                                  archiveDetail["user_family"] +
                                                                                  " -  شماره همراه : " +
                                                                                  archiveDetail["user_mobile"]}
                                                                            </Typography>
                                                                      </div>
                                                                </Grid>

                                                                <Grid item xs={4}>
                                                                      <div style={{ width: "100%", textAlign: "right" }}>
                                                                            <Typography align="center" variant="h7">
                                                                                  {"مشخصات نماینده: " +
                                                                                  archiveDetail["agent_name"] +
                                                                                  " " +
                                                                                  archiveDetail["agent_family"] +
                                                                                  " -  شماره همراه : " +
                                                                                  archiveDetail["agent_mobile"] +
                                                                                  " - کد : " +
                                                                                  archiveDetail["agent_code"]}
                                                                            </Typography>
                                                                      </div>
                                                                </Grid>

                                                                <Grid item xs={4}>
                                                                      <div style={{ width: "100%", textAlign: "right" }}>
                                                                            <Typography align="center" variant="h7">
                                                                                  {"استان : " +
                                                                                  archiveDetail["agent_state_name"] +
                                                                                  "   - شهرستان:  " +
                                                                                  archiveDetail["agent_city_name"]}
                                                                            </Typography>
                                                                      </div>
                                                                </Grid>

                                                                {request_ready ? (
                                                                    <Grid item xs={12}>
                                                                          <Grid container spacing={3}>
                                                                                <Grid item xs={3}>
                                                                                      <Typography align="center" variant="h7">
                                                                                            {"شماره بیمه نامه:" +
                                                                                            request_ready["requst_ready_num_ins"]}
                                                                                      </Typography>
                                                                                </Grid>
                                                                                <Grid item xs={3}>
                                                                                      <Typography align="center" variant="h7">
                                                                                            {"قیمت اعلام شده نماینده:"}
                                                                                            <NumberFormat
                                                                                                displayType={"text"}
                                                                                                value={
                                                                                                      request_ready["requst_ready_end_price"]
                                                                                                }
                                                                                                thousandSeparator={true}
                                                                                                prefix={" ریال"}
                                                                                            />
                                                                                      </Typography>
                                                                                </Grid>
                                                                                <Grid item xs={3}>
                                                                                      <Typography variant="h7">
                                                                                            {"تاریخ شروع : "}
                                                                                            {new JDate(
                                                                                                new Date(
                                                                                                    parseInt(
                                                                                                        Moment(
                                                                                                            request_ready[
                                                                                                                "requst_ready_start_date"
                                                                                                                ],
                                                                                                            "YYYY-M-D HH:mm:ss"
                                                                                                        ).format("x")
                                                                                                    )
                                                                                                )
                                                                                            ).format("YYYY/MM/DD ")}
                                                                                      </Typography>
                                                                                </Grid>
                                                                                <Grid item xs={3}>
                                                                                      <Typography variant="h7">
                                                                                            {"تاریخ پایان: "}
                                                                                            {new JDate(
                                                                                                new Date(
                                                                                                    parseInt(
                                                                                                        Moment(
                                                                                                            request_ready["requst_ready_end_date"],
                                                                                                            "YYYY-M-D HH:mm:ss"
                                                                                                        ).format("x")
                                                                                                    )
                                                                                                )
                                                                                            ).format("YYYY/MM/DD ")}
                                                                                      </Typography>
                                                                                </Grid>
                                                                          </Grid>
                                                                    </Grid>
                                                                ) : null}
                                                                <Grid item xs={12}>
                                                                      <Divider />
                                                                </Grid>

                                                                <Grid item xs={12}>
                                                                      <Typography align="center" variant="h6">
                                                                            {archiveDetail["user_pey_amount"] === null ||
                                                                            archiveDetail["user_pey_amount"] === ""
                                                                                ? "مبلغ پرداخت شده : 0 ریال"
                                                                                : "مبلغ پرداخت شده :  "}
                                                                            {archiveDetail["user_pey_amount"] === null ||
                                                                            archiveDetail["user_pey_amount"] === "" ? null : (
                                                                                <NumberFormat
                                                                                    displayType={"text"}
                                                                                    value={archiveDetail["user_pey_amount"]}
                                                                                    thousandSeparator={true}
                                                                                    prefix={" ریال"}
                                                                                />
                                                                            )}
                                                                      </Typography>
                                                                </Grid>

                                                                <Grid item xs={6}>
                                                                      <Typography align="center" variant="h6">
                                                                            {archiveDetail["user_pey_cash"] === null ||
                                                                            archiveDetail["user_pey_cash"] === ""
                                                                                ? "مبلغ نقدی پرداخت شده : 0 ریال"
                                                                                : "مبلغ نقدی پرداخت شده :  "}
                                                                            {archiveDetail["user_pey_cash"] === null ||
                                                                            archiveDetail["user_pey_cash"] === "" ? null : (
                                                                                <NumberFormat
                                                                                    displayType={"text"}
                                                                                    value={archiveDetail["user_pey_cash"]}
                                                                                    thousandSeparator={true}
                                                                                    prefix={" ریال"}
                                                                                />
                                                                            )}
                                                                      </Typography>
                                                                </Grid>

                                                                <Grid item xs={6}>
                                                                      <Typography align="center" variant="h6">
                                                                            {archiveDetail["user_pey_instalment"] === null ||
                                                                            archiveDetail["user_pey_instalment"] === ""
                                                                                ? "مبلغ اقساط پرداخت شده : 0 ریال"
                                                                                : "مبلغ اقساط پرداخت شده :  "}
                                                                            {archiveDetail["user_pey_instalment"] === null ||
                                                                            archiveDetail["user_pey_instalment"] === "" ? null : (
                                                                                <NumberFormat
                                                                                    displayType={"text"}
                                                                                    value={archiveDetail["user_pey_instalment"]}
                                                                                    thousandSeparator={true}
                                                                                    prefix={" ریال"}
                                                                                />
                                                                            )}
                                                                      </Typography>
                                                                </Grid>

                                                                <Grid item xs={6}>
                                                                      {user_pey_detail2 ? (
                                                                          <TableContainer component={Paper}>
                                                                                <Table
                                                                                    className={classes.table}
                                                                                    aria-label="simple table"
                                                                                >
                                                                                      <TableHead>
                                                                                            <TableRow>
                                                                                                  <TableCell align="center">
                                                                                                        {" "}
                                                                                                        مبلغ پرداخت شده
                                                                                                  </TableCell>
                                                                                                  <TableCell align="center">توضیحات</TableCell>
                                                                                            </TableRow>
                                                                                      </TableHead>
                                                                                      <TableBody>
                                                                                            {user_pey_detail2.map((row) => (
                                                                                                <TableRow key={row.user_pey_amount}>
                                                                                                      <TableCell align="center">
                                                                                                            <NumberFormat
                                                                                                                displayType={"text"}
                                                                                                                value={row.user_pey_amount}
                                                                                                                thousandSeparator={true}
                                                                                                                prefix={" ریال"}
                                                                                                            />
                                                                                                      </TableCell>
                                                                                                      <TableCell align="center">
                                                                                                            {row.user_pey_desc}
                                                                                                      </TableCell>
                                                                                                </TableRow>
                                                                                            ))}
                                                                                      </TableBody>
                                                                                </Table>
                                                                          </TableContainer>
                                                                      ) : null}
                                                                </Grid>

                                                                <Grid item xs={6}>
                                                                      {user_pey_detail ? (
                                                                          <TableContainer component={Paper}>
                                                                                <Table
                                                                                    className={classes.table}
                                                                                    aria-label="simple table"
                                                                                >
                                                                                      <TableHead>
                                                                                            <TableRow>
                                                                                                  <TableCell align="center">
                                                                                                        {" "}
                                                                                                        مبلغ پرداخت شده
                                                                                                  </TableCell>
                                                                                                  <TableCell align="center">توضیحات</TableCell>
                                                                                                  <TableCell align="center">تصویر </TableCell>
                                                                                                  <TableCell align="center">تاریخ</TableCell>
                                                                                                  <TableCell align="center">شماره چک</TableCell>
                                                                                            </TableRow>
                                                                                      </TableHead>
                                                                                      <TableBody>
                                                                                            {user_pey_detail.map((row) => {
                                                                                                  return (
                                                                                                      <TableRow key={row.user_pey_amount}>
                                                                                                            <TableCell align="center">
                                                                                                                  <NumberFormat
                                                                                                                      displayType={"text"}
                                                                                                                      value={row.user_pey_amount}
                                                                                                                      thousandSeparator={true}
                                                                                                                      prefix={" ریال"}
                                                                                                                  />
                                                                                                            </TableCell>
                                                                                                            <TableCell align="center">
                                                                                                                  {row.user_pey_desc}
                                                                                                            </TableCell>
                                                                                                            <TableCell align="center">
                                                                                                                  <Avatar
                                                                                                                      variant="rounded"
                                                                                                                      alt="Remy Sharp"
                                                                                                                      src={row.user_pey_image_turl}
                                                                                                                      onClick={() => {
                                                                                                                            this.setImageModel(
                                                                                                                                row.user_pey_image_turl,
                                                                                                                                row.user_pey_image_url,
                                                                                                                                "عکس چک های سفارش "
                                                                                                                            );
                                                                                                                      }}
                                                                                                                  />
                                                                                                            </TableCell>
                                                                                                            <TableCell align="center">
                                                                                                                  {row.instalment_check_date}{" "}
                                                                                                            </TableCell>
                                                                                                            <TableCell align="center">
                                                                                                                  {row.instalment_check_num}
                                                                                                            </TableCell>
                                                                                                      </TableRow>
                                                                                                  );
                                                                                            })}
                                                                                      </TableBody>
                                                                                </Table>
                                                                          </TableContainer>
                                                                      ) : null}
                                                                </Grid>
                                                                <Grid item xs={12}>
                                                                      <Divider />
                                                                </Grid>
                                                          </Grid>
                                                          <Grid container spacing={3}>
                                                                {request_financial_approval ? (
                                                                    <Grid item xs={12}>
                                                                          <Grid container spacing={3}>
                                                                                <Grid item xs={12}>
                                                                                      <Typography variant="h6">
                                                                                            {"تایید مالی بیمه نامه"}
                                                                                      </Typography>
                                                                                </Grid>

                                                                                <Grid item xs={3}>
                                                                                      <Typography align="center" variant="h7">
                                                                                            {"قیمت تایید شد:  "}
                                                                                            <NumberFormat
                                                                                                displayType={"text"}
                                                                                                value={
                                                                                                      request_financial_approval[
                                                                                                          "request_financial_approval_price"
                                                                                                          ]
                                                                                                }
                                                                                                thousandSeparator={true}
                                                                                                prefix={" ریال"}
                                                                                            />
                                                                                      </Typography>
                                                                                </Grid>
                                                                                <Grid item xs={3}>
                                                                                      <Typography align="center" variant="h7">
                                                                                            {"اختلاف قیمت:  "}
                                                                                            <NumberFormat
                                                                                                displayType={"text"}
                                                                                                value={
                                                                                                      request_financial_approval[
                                                                                                          "request_financial_approval_difference_price"
                                                                                                          ]
                                                                                                }
                                                                                                thousandSeparator={true}
                                                                                                prefix={" ریال"}
                                                                                            />
                                                                                      </Typography>
                                                                                </Grid>
                                                                                <Grid item xs={6}>
                                                                                      <Typography align="center" variant="h7">
                                                                                            {"توضیحات:  "}
                                                                                            <NumberFormat
                                                                                                displayType={"text"}
                                                                                                value={
                                                                                                      request_financial_approval[
                                                                                                          "request_financial_approval_desc"
                                                                                                          ]
                                                                                                }
                                                                                                thousandSeparator={true}
                                                                                                prefix={" ریال"}
                                                                                            />
                                                                                      </Typography>
                                                                                </Grid>

                                                                                <Grid item xs={4}>
                                                                                      <Typography align="center" variant="h7">
                                                                                            {"نام کارمند :" +
                                                                                            request_financial_approval["employee_name"] +
                                                                                            " " +
                                                                                            request_financial_approval["employee_family"]}
                                                                                      </Typography>
                                                                                </Grid>
                                                                                <Grid item xs={4}>
                                                                                      <Typography variant="h7">
                                                                                            {"تاریخ بررسی: "}
                                                                                            {new JDate(
                                                                                                new Date(
                                                                                                    parseInt(
                                                                                                        Moment(
                                                                                                            request_financial_approval[
                                                                                                                "request_financial_approval_date"
                                                                                                                ],
                                                                                                            "YYYY-M-D HH:mm:ss"
                                                                                                        ).format("x")
                                                                                                    )
                                                                                                )
                                                                                            ).format("YYYY/MM/DD") +
                                                                                            " " +
                                                                                            Moment(
                                                                                                request_financial_approval[
                                                                                                    "request_financial_approval_date"
                                                                                                    ],
                                                                                                "YYYY-M-D HH:mm:ss"
                                                                                            ).format("HH:mm:ss")}
                                                                                      </Typography>
                                                                                </Grid>
                                                                          </Grid>
                                                                    </Grid>
                                                                ) : null}

                                                                {request_financial_doc ? (
                                                                    <Grid item xs={12}>
                                                                          <Grid container spacing={3}>
                                                                                <Grid item xs={12}>
                                                                                      <Divider />
                                                                                </Grid>
                                                                                <Grid item xs={12}>
                                                                                      <Typography variant="h6">
                                                                                            {"سند مالی در حال پرداخت"}
                                                                                      </Typography>
                                                                                </Grid>

                                                                                <Grid item xs={3}>
                                                                                      <Typography align="center" variant="h7">
                                                                                            {"شماره سند:  " +
                                                                                            request_financial_doc[
                                                                                                "request_financial_doc_num"
                                                                                                ]}
                                                                                      </Typography>
                                                                                </Grid>
                                                                                <Grid item xs={3}>
                                                                                      <Typography align="center" variant="h7">
                                                                                            {"مبلغ کل سند:  "}
                                                                                            <NumberFormat
                                                                                                displayType={"text"}
                                                                                                value={
                                                                                                      request_financial_doc[
                                                                                                          "request_financial_doc_price"
                                                                                                          ]
                                                                                                }
                                                                                                thousandSeparator={true}
                                                                                                prefix={" ریال"}
                                                                                            />
                                                                                      </Typography>
                                                                                </Grid>

                                                                                <Grid item xs={4}>
                                                                                      <Typography align="center" variant="h7">
                                                                                            {"نام کارمند :" +
                                                                                            request_financial_doc["employee_name"] +
                                                                                            " " +
                                                                                            request_financial_doc["employee_family"]}
                                                                                      </Typography>
                                                                                </Grid>
                                                                                <Grid item xs={4}>
                                                                                      <Typography variant="h7">
                                                                                            {"تاریخ صدور سند: "}
                                                                                            {new JDate(
                                                                                                new Date(
                                                                                                    parseInt(
                                                                                                        Moment(
                                                                                                            request_financial_doc[
                                                                                                                "request_financial_doc_date"
                                                                                                                ],
                                                                                                            "YYYY-M-D HH:mm:ss"
                                                                                                        ).format("x")
                                                                                                    )
                                                                                                )
                                                                                            ).format("YYYY/MM/DD") +
                                                                                            " " +
                                                                                            Moment(
                                                                                                request_financial_doc[
                                                                                                    "request_financial_doc_date"
                                                                                                    ],
                                                                                                "YYYY-M-D HH:mm:ss"
                                                                                            ).format("HH:mm:ss")}
                                                                                      </Typography>
                                                                                </Grid>
                                                                                <Grid item xs={12}>
                                                                                      <Divider />
                                                                                </Grid>

                                                                                <Grid item xs={4}>
                                                                                      <Typography variant="h7">
                                                                                            {"تاریخ پرداخت: "}
                                                                                            {new JDate(
                                                                                                new Date(
                                                                                                    parseInt(
                                                                                                        Moment(
                                                                                                            request_financial_doc[
                                                                                                                "request_financial_doc_peydate"
                                                                                                                ],
                                                                                                            "YYYY-M-D HH:mm:ss"
                                                                                                        ).format("x")
                                                                                                    )
                                                                                                )
                                                                                            ).format("YYYY/MM/DD")}
                                                                                      </Typography>
                                                                                </Grid>
                                                                                <Grid item xs={4}>
                                                                                      <Typography variant="h7">
                                                                                            {"کد رهگیری پرداخت: "}
                                                                                            {
                                                                                                  request_financial_doc[
                                                                                                      "request_financial_doc_code"
                                                                                                      ]
                                                                                            }
                                                                                      </Typography>
                                                                                </Grid>

                                                                                <Grid item xs={4}>
                                                                                      {"نام کارمند :" +
                                                                                      request_financial_doc["pey_employee_name"] +
                                                                                      " " +
                                                                                      request_financial_doc["pey_employee_family"]}
                                                                                </Grid>
                                                                          </Grid>
                                                                    </Grid>
                                                                ) : null}

                                                                <Grid item xs={3}>
                                                                      <FloatingLabelInput
                                                                          type="number"
                                                                          placeholder="همراه هماهنگ کننده فروش"
                                                                          value={reagent_mobile}
                                                                          handleInputt={this.handleChangeReagentMobile}
                                                                      />
                                                                </Grid>
                                                                <Grid item xs={3}>
                                                                      <Button
                                                                          variant="outlined"
                                                                          color="primary"
                                                                          onClick={(e) => {
                                                                                this.checkRagentMobile(
                                                                                    0,
                                                                                    archiveDetail["request_id"]
                                                                                );
                                                                          }}
                                                                      >
                                                                            {"بررسی شماره همراه"}
                                                                      </Button>
                                                                </Grid>
                                                                <Grid item xs={3}>
                                                                      <Button
                                                                          variant="outlined"
                                                                          color="primary"
                                                                          onClick={(e) => {
                                                                                this.checkRagentMobile(
                                                                                    1,
                                                                                    archiveDetail["request_id"]
                                                                                );
                                                                          }}
                                                                      >
                                                                            {"تغییر شماره همراه همکار فروش"}
                                                                      </Button>
                                                                </Grid>
                                                                <Grid item xs={3}>
                                                                      <div style={{ width: "100%", textAlign: "left" }}>
                                                                            <Button
                                                                                variant="outlined"
                                                                                color="primary"
                                                                                onClick={this.hidePaperDetail}
                                                                            >
                                                                                  {"بستن"}
                                                                            </Button>
                                                                      </div>
                                                                </Grid>
                                                          </Grid>
                                                    </Paper>
                                              </Container>
                                        </Collapse>
                                  </Grid>

                                  <Grid item xs={12}>
                                        <Container maxWidth="lg">
                                              <Paper className={classes.root}>
                                                    <Grid container spacing={3}>
                                                          <Grid item xs={4}>
                                                                <Typography variant="h7">
                                                                      {"جمع حق بیمه:"}
                                                                      <NumberFormat
                                                                          displayType={"text"}
                                                                          value={sumPayIns}
                                                                          thousandSeparator={true}
                                                                          prefix={" ریال"}
                                                                      />
                                                                </Typography>
                                                          </Grid>
                                                          <Grid item xs={4}>
                                                                <Typography variant="h7">
                                                                      {"جمع کارمزد:"}
                                                                      <NumberFormat
                                                                          displayType={"text"}
                                                                          value={sumCommission}
                                                                          thousandSeparator={true}
                                                                          prefix={" ریال"}
                                                                      />
                                                                </Typography>
                                                          </Grid>

                                                          <Grid item xs={4}>
                                                                <Typography variant="h7">
                                                                      {"جمع کمیسیون های پرداختی:"}
                                                                      <NumberFormat
                                                                          displayType={"text"}
                                                                          value={sumPeyCommision}
                                                                          thousandSeparator={true}
                                                                          prefix={" ریال"}
                                                                      />
                                                                </Typography>
                                                          </Grid>

                                                          <Grid item xs={4}>
                                                                <Typography variant="h7">
                                                                      {"جمع کمیسیون های پرداختی به همکار فروش:"}
                                                                      <NumberFormat
                                                                          displayType={"text"}
                                                                          value={sumPeyCommisionMarketer}
                                                                          thousandSeparator={true}
                                                                          prefix={" ریال"}
                                                                      />
                                                                </Typography>
                                                          </Grid>

                                                          <Grid item xs={4}>
                                                                <Typography variant="h7">
                                                                      {"جمع کمیسیون های پرداختی به هماهنگ کننده:"}
                                                                      <NumberFormat
                                                                          displayType={"text"}
                                                                          value={sumPeyCommisionLeader}
                                                                          thousandSeparator={true}
                                                                          prefix={" ریال"}
                                                                      />
                                                                </Typography>
                                                          </Grid>

                                                          <Grid item xs={4}>
                                                                <Typography variant="h7">
                                                                      {"جمع کمیسیون های پرداختی به کاربران معمولی:"}
                                                                      <NumberFormat
                                                                          displayType={"text"}
                                                                          value={sumPeyCommisionUser}
                                                                          thousandSeparator={true}
                                                                          prefix={" ریال"}
                                                                      />
                                                                </Typography>
                                                          </Grid>
                                                    </Grid>
                                              </Paper>
                                        </Container>
                                  </Grid>

                                  <Grid item xs={12}>
                                        <Container maxWidth="false">
                                              <Paper className={classes.root}>
                                                    <ReactHTMLTableToExcel
                                                        id="test-table-xls-button"
                                                        className="download-table-xls-button"
                                                        table="table-to-xls"
                                                        filename="tablexls"
                                                        sheet="tablexls"
                                                        buttonText="Download as XLS"
                                                    />

                                                    <TableContainer dir="rtl">
                                                          <Table id="table-to-xls" aria-label="sticky table">
                                                                <TableHead>
                                                                      <TableRow>
                                                                            <TableCell
                                                                                key={"request_id"}
                                                                                align={"center"}
                                                                                style={{ minWidth: 30 }}
                                                                                sortDirection={
                                                                                      orderBy === "request_id" ? order : false
                                                                                }
                                                                            >
                                                                                  {"شماره"}
                                                                                  <TableSortLabel
                                                                                      active={orderBy === "request_id"}
                                                                                      direction={
                                                                                            orderBy === "request_id" ? order : "asc"
                                                                                      }
                                                                                      onClick={(e) => {
                                                                                            this.createSortHandler("request_id");
                                                                                      }}
                                                                                  ></TableSortLabel>
                                                                            </TableCell>

                                                                            <TableCell
                                                                                key={"request_company_id"}
                                                                                align={"center"}
                                                                                style={{ minWidth: 60 }}
                                                                            >
                                                                                  {"شرکت بیمه"}
                                                                                  <TableSortLabel
                                                                                      active={orderBy === "request_company_id"}
                                                                                      direction={
                                                                                            orderBy === "request_company_id" ? order : "asc"
                                                                                      }
                                                                                      onClick={(e) => {
                                                                                            this.createSortHandler("request_company_id");
                                                                                      }}
                                                                                  ></TableSortLabel>
                                                                            </TableCell>

                                                                            <TableCell
                                                                                key={"agent_id"}
                                                                                align={"center"}
                                                                                style={{ minWidth: 60 }}
                                                                            >
                                                                                  {"نماینده"}
                                                                                  <TableSortLabel
                                                                                      active={orderBy === "agent_id"}
                                                                                      direction={orderBy === "agent_id" ? order : "asc"}
                                                                                      onClick={(e) => {
                                                                                            this.createSortHandler("agent_id");
                                                                                      }}
                                                                                  ></TableSortLabel>
                                                                            </TableCell>

                                                                            <TableCell
                                                                                key={"request_fieldinsurance_fa"}
                                                                                align={"center"}
                                                                                style={{ minWidth: 60 }}
                                                                            >
                                                                                  {"رشته بیمه"}
                                                                                  <TableSortLabel
                                                                                      active={orderBy === "request_fieldinsurance_fa"}
                                                                                      direction={
                                                                                            orderBy === "request_fieldinsurance_fa"
                                                                                                ? order
                                                                                                : "asc"
                                                                                      }
                                                                                      onClick={(e) => {
                                                                                            this.createSortHandler(
                                                                                                "request_fieldinsurance_fa"
                                                                                            );
                                                                                      }}
                                                                                  ></TableSortLabel>
                                                                            </TableCell>

                                                                            <TableCell
                                                                                key={"agent_state_id"}
                                                                                align={"center"}
                                                                                style={{ minWidth: 60 }}
                                                                            >
                                                                                  {"مشخصات کاربر"}
                                                                                  <TableSortLabel
                                                                                      active={orderBy === "user_id"}
                                                                                      direction={orderBy === "user_id" ? order : "asc"}
                                                                                      onClick={(e) => {
                                                                                            this.createSortHandler("user_id");
                                                                                      }}
                                                                                  ></TableSortLabel>
                                                                            </TableCell>

                                                                            <TableCell
                                                                                key={"requestpartner"}
                                                                                align={"center"}
                                                                                style={{ minWidth: 60 }}
                                                                            >
                                                                                  {"کد سفارش همکار"}
                                                                                  <TableSortLabel
                                                                                      active={orderBy === "requestpartner"}
                                                                                      direction={
                                                                                            orderBy === "requestpartner" ? order : "asc"
                                                                                      }
                                                                                      onClick={(e) => {
                                                                                            this.createSortHandler("requestpartner");
                                                                                      }}
                                                                                  ></TableSortLabel>
                                                                            </TableCell>

                                                                            <TableCell
                                                                                key={"agent_state_id"}
                                                                                align={"center"}
                                                                                style={{ minWidth: 60 }}
                                                                            >
                                                                                  {"تاریخ صدور"}
                                                                                  <TableSortLabel
                                                                                      active={orderBy === "requst_ready_timestamp"}
                                                                                      direction={
                                                                                            orderBy === "requst_ready_timestamp"
                                                                                                ? order
                                                                                                : "asc"
                                                                                      }
                                                                                      onClick={(e) => {
                                                                                            this.createSortHandler(
                                                                                                "requst_ready_timestamp"
                                                                                            );
                                                                                      }}
                                                                                  ></TableSortLabel>
                                                                            </TableCell>

                                                                            <TableCell
                                                                                key={"agent_state_id"}
                                                                                align={"center"}
                                                                                style={{ minWidth: 60 }}
                                                                            >
                                                                                  {"شماره بیمه نامه"}
                                                                                  <TableSortLabel
                                                                                      active={orderBy === "requst_ready_num_ins"}
                                                                                      direction={
                                                                                            orderBy === "requst_ready_num_ins"
                                                                                                ? order
                                                                                                : "asc"
                                                                                      }
                                                                                      onClick={(e) => {
                                                                                            this.createSortHandler("requst_ready_num_ins");
                                                                                      }}
                                                                                  ></TableSortLabel>
                                                                            </TableCell>

                                                                            <TableCell
                                                                                key={"user_pey_instalment"}
                                                                                align={"center"}
                                                                                style={{ minWidth: 60 }}
                                                                            >
                                                                                  {"مبلغ کل اقساط"}
                                                                                  <TableSortLabel
                                                                                      active={orderBy === "user_pey_instalment"}
                                                                                      direction={
                                                                                            orderBy === "user_pey_instalment"
                                                                                                ? order
                                                                                                : "asc"
                                                                                      }
                                                                                      onClick={(e) => {
                                                                                            this.createSortHandler("user_pey_instalment");
                                                                                      }}
                                                                                  ></TableSortLabel>
                                                                            </TableCell>

                                                                            <TableCell
                                                                                key={"user_pey_instalment_pass"}
                                                                                align={"center"}
                                                                                style={{ minWidth: 60 }}
                                                                            >
                                                                                  {"اقساط پاس شده"}
                                                                                  <TableSortLabel
                                                                                      active={orderBy === "user_pey_instalment_pass"}
                                                                                      direction={
                                                                                            orderBy === "user_pey_instalment_pass"
                                                                                                ? order
                                                                                                : "asc"
                                                                                      }
                                                                                      onClick={(e) => {
                                                                                            this.createSortHandler(
                                                                                                "user_pey_instalment_pass"
                                                                                            );
                                                                                      }}
                                                                                  ></TableSortLabel>
                                                                            </TableCell>

                                                                            <TableCell
                                                                                key={"requst_ready_code_penalty"}
                                                                                align={"center"}
                                                                                style={{ minWidth: 60 }}
                                                                            >
                                                                                  {" مبلغ جریمه"}
                                                                                  <TableSortLabel
                                                                                      active={orderBy === "requst_ready_code_penalty"}
                                                                                      direction={
                                                                                            orderBy === "requst_ready_code_penalty"
                                                                                                ? order
                                                                                                : "asc"
                                                                                      }
                                                                                      onClick={(e) => {
                                                                                            this.createSortHandler(
                                                                                                "requst_ready_code_penalty"
                                                                                            );
                                                                                      }}
                                                                                  ></TableSortLabel>
                                                                            </TableCell>

                                                                            <TableCell
                                                                                key={"user_pey_cash"}
                                                                                align={"center"}
                                                                                style={{ minWidth: 60 }}
                                                                            >
                                                                                  {"مبلغ نقدی کل "}
                                                                                  <TableSortLabel
                                                                                      active={orderBy === "user_pey_cash"}
                                                                                      direction={
                                                                                            orderBy === "user_pey_cash" ? order : "asc"
                                                                                      }
                                                                                      onClick={(e) => {
                                                                                            this.createSortHandler("user_pey_cash");
                                                                                      }}
                                                                                  ></TableSortLabel>
                                                                            </TableCell>

                                                                            <TableCell
                                                                                key={"requst_ready_end_price"}
                                                                                align={"center"}
                                                                                style={{ minWidth: 60 }}
                                                                            >
                                                                                  {"حق بیمه کل"}
                                                                                  <TableSortLabel
                                                                                      active={orderBy === "requst_ready_end_price"}
                                                                                      direction={
                                                                                            orderBy === "requst_ready_end_price"
                                                                                                ? order
                                                                                                : "asc"
                                                                                      }
                                                                                      onClick={(e) => {
                                                                                            this.createSortHandler(
                                                                                                "requst_ready_end_price"
                                                                                            );
                                                                                      }}
                                                                                  ></TableSortLabel>
                                                                            </TableCell>

                                                                            <TableCell
                                                                                key={"fieldinsurance_commission"}
                                                                                align={"center"}
                                                                                style={{ minWidth: 60 }}
                                                                            >
                                                                                  {"کارمزد"}
                                                                                  <TableSortLabel
                                                                                      active={orderBy === "fieldinsurance_commission"}
                                                                                      direction={
                                                                                            orderBy === "fieldinsurance_commission"
                                                                                                ? order
                                                                                                : "asc"
                                                                                      }
                                                                                      onClick={(e) => {
                                                                                            this.createSortHandler(
                                                                                                "fieldinsurance_commission"
                                                                                            );
                                                                                      }}
                                                                                  ></TableSortLabel>
                                                                            </TableCell>


                                                                            <TableCell
                                                                                key={"fieldinsurance_commission"}
                                                                                align={"center"}
                                                                                style={{ minWidth: 60 }}
                                                                            >
                                                                                  {"کارمزد وصول شده"}
                                                                                  <TableSortLabel
                                                                                      active={orderBy === "fieldinsurance_commission"}
                                                                                      direction={
                                                                                            orderBy === "fieldinsurance_commission"
                                                                                                ? order
                                                                                                : "asc"
                                                                                      }
                                                                                      onClick={(e) => {
                                                                                            this.createSortHandler(
                                                                                                "fieldinsurance_commission"
                                                                                            );
                                                                                      }}
                                                                                  ></TableSortLabel>
                                                                            </TableCell>

                                                                            <TableCell
                                                                                key={"peysumcommision"}
                                                                                align={"center"}
                                                                                style={{ minWidth: 60 }}
                                                                            >
                                                                                  {"کمیسیون های پرداختی"}
                                                                                  <TableSortLabel
                                                                                      active={orderBy === "peysumcommision"}
                                                                                      direction={
                                                                                            orderBy === "peysumcommision" ? order : "asc"
                                                                                      }
                                                                                      onClick={(e) => {
                                                                                            this.createSortHandler("peysumcommision");
                                                                                      }}
                                                                                  ></TableSortLabel>
                                                                            </TableCell>

                                                                            <TableCell
                                                                                key={"peycommision_marketer"}
                                                                                align={"center"}
                                                                                style={{ minWidth: 60 }}
                                                                            >
                                                                                  {"کمیسیون  همکار فروش"}
                                                                                  <TableSortLabel
                                                                                      active={orderBy === "peycommision_marketer"}
                                                                                      direction={
                                                                                            orderBy === "peycommision_marketer"
                                                                                                ? order
                                                                                                : "asc"
                                                                                      }
                                                                                      onClick={(e) => {
                                                                                            this.createSortHandler("peycommision_marketer");
                                                                                      }}
                                                                                  ></TableSortLabel>
                                                                            </TableCell>

                                                                            <TableCell
                                                                                key={"peycommision_marketer_id"}
                                                                                align={"center"}
                                                                                style={{ minWidth: 60 }}
                                                                            >
                                                                                  {"  همکار فروش"}
                                                                                  <TableSortLabel
                                                                                      active={orderBy === "peycommision_marketer_id"}
                                                                                      direction={
                                                                                            orderBy === "peycommision_marketer_id"
                                                                                                ? order
                                                                                                : "asc"
                                                                                      }
                                                                                      onClick={(e) => {
                                                                                            this.createSortHandler(
                                                                                                "peycommision_marketer_id"
                                                                                            );
                                                                                      }}
                                                                                  ></TableSortLabel>
                                                                            </TableCell>

                                                                            <TableCell
                                                                                key={"peycommision_leader"}
                                                                                align={"center"}
                                                                                style={{ minWidth: 60 }}
                                                                            >
                                                                                  {"کمیسیون  هماهنگ کننده"}
                                                                                  <TableSortLabel
                                                                                      active={orderBy === "peycommision_leader"}
                                                                                      direction={
                                                                                            orderBy === "peycommision_leader"
                                                                                                ? order
                                                                                                : "asc"
                                                                                      }
                                                                                      onClick={(e) => {
                                                                                            this.createSortHandler("peycommision_leader");
                                                                                      }}
                                                                                  ></TableSortLabel>
                                                                            </TableCell>

                                                                            <TableCell
                                                                                key={"peycommision_leader_id"}
                                                                                align={"center"}
                                                                                style={{ minWidth: 60 }}
                                                                            >
                                                                                  {"کمیسیون  هماهنگ کننده"}
                                                                                  <TableSortLabel
                                                                                      active={orderBy === "peycommision_leader_id"}
                                                                                      direction={
                                                                                            orderBy === "peycommision_leader_id"
                                                                                                ? order
                                                                                                : "asc"
                                                                                      }
                                                                                      onClick={(e) => {
                                                                                            this.createSortHandler(
                                                                                                "peycommision_leader_id"
                                                                                            );
                                                                                      }}
                                                                                  ></TableSortLabel>
                                                                            </TableCell>

                                                                            <TableCell></TableCell>
                                                                      </TableRow>
                                                                </TableHead>

                                                                <TableBody>
                                                                      {requestinfofilter && requestinfofilter.slice(0, rowsPerPage).map((row) => {
                                                                            return (
                                                                                <TableRow
                                                                                    hover
                                                                                    role="checkbox"
                                                                                    tabIndex={-1}
                                                                                    key={row["request_id"]}
                                                                                    value={row}
                                                                                >
                                                                                      <TableCell key={"request_id"} align={"center"}>
                                                                                            {row["request_id"]}
                                                                                      </TableCell>

                                                                                      <TableCell
                                                                                          key={"request_company_id"}
                                                                                          align={"center"}
                                                                                      >
                                                                                            {row["company_name"]}
                                                                                      </TableCell>

                                                                                      <TableCell key={"agent_id"} align={"center"}>
                                                                                            {row["agent_name"] +
                                                                                            " " +
                                                                                            row["agent_family"] +
                                                                                            " - کد : " +
                                                                                            row["agent_code"]}
                                                                                      </TableCell>

                                                                                      <TableCell
                                                                                          key={"request_fieldinsurance_fa"}
                                                                                          align={"center"}
                                                                                      >
                                                                                            {row["request_fieldinsurance_fa"]}
                                                                                      </TableCell>

                                                                                      <TableCell key={"user_id"} align={"center"}>
                                                                                            {row["user_name"] +
                                                                                            " " +
                                                                                            row["user_family"] +
                                                                                            " - کد : " +
                                                                                            row["user_id"]}
                                                                                            {"شماره همراه : " + row["user_mobile"]}
                                                                                      </TableCell>

                                                                                      <TableCell
                                                                                          key={"requestpartner"}
                                                                                          align={"center"}
                                                                                      >
                                                                                            {row["requestpartner"]}
                                                                                      </TableCell>

                                                                                      <TableCell
                                                                                          key={"requst_ready_timestamp"}
                                                                                          align={"center"}
                                                                                      >
                                                                                            {new JDate(
                                                                                                new Date(
                                                                                                    parseInt(
                                                                                                        Moment(
                                                                                                            row["requst_ready_timestamp"],
                                                                                                            "YYYY-M-D HH:mm:ss"
                                                                                                        ).format("x")
                                                                                                    )
                                                                                                )
                                                                                            ).format("YYYY/MM/DD ")}
                                                                                      </TableCell>

                                                                                      <TableCell
                                                                                          key={"requst_ready_num_ins"}
                                                                                          align={"center"}
                                                                                      >
                                                                                            {row["requst_ready_num_ins"]}
                                                                                      </TableCell>

                                                                                      <TableCell
                                                                                          key={"user_pey_instalment"}
                                                                                          align={"center"}
                                                                                      >
                                                                                            {
                                                                                                  <NumberFormat
                                                                                                      displayType={"text"}
                                                                                                      value={row["user_pey_instalment"]}
                                                                                                      thousandSeparator={true}
                                                                                                      prefix={" ریال"}
                                                                                                  />
                                                                                            }
                                                                                      </TableCell>

                                                                                      <TableCell
                                                                                          key={"user_pey_instalment_pass"}
                                                                                          align={"center"}
                                                                                      >
                                                                                            {
                                                                                                  <NumberFormat
                                                                                                      displayType={"text"}
                                                                                                      value={row["user_pey_instalment_pass"]}
                                                                                                      thousandSeparator={true}
                                                                                                      prefix={" ریال"}
                                                                                                  />
                                                                                            }
                                                                                      </TableCell>

                                                                                      <TableCell
                                                                                          key={"requst_ready_code_penalty"}
                                                                                          align={"center"}
                                                                                      >
                                                                                            {
                                                                                                  <NumberFormat
                                                                                                      displayType={"text"}
                                                                                                      value={row["requst_ready_code_penalty"]}
                                                                                                      thousandSeparator={true}
                                                                                                      prefix={" ریال"}
                                                                                                  />
                                                                                            }
                                                                                      </TableCell>

                                                                                      <TableCell key={"user_pey_cash"} align={"center"}>
                                                                                            {
                                                                                                  <NumberFormat
                                                                                                      displayType={"text"}
                                                                                                      value={row["user_pey_cash"]}
                                                                                                      thousandSeparator={true}
                                                                                                      prefix={" ریال"}
                                                                                                  />
                                                                                            }
                                                                                      </TableCell>

                                                                                      <TableCell
                                                                                          key={"requst_ready_end_price"}
                                                                                          align={"center"}
                                                                                      >
                                                                                            {
                                                                                                  <NumberFormat
                                                                                                      displayType={"text"}
                                                                                                      value={row["requst_ready_end_price"]}
                                                                                                      thousandSeparator={true}
                                                                                                      prefix={" ریال"}
                                                                                                  />
                                                                                            }
                                                                                      </TableCell>

                                                                                      <TableCell
                                                                                          key={"fieldinsurance_commission"}
                                                                                          align={"center"}
                                                                                      >
                                                                                            {
                                                                                                  <NumberFormat
                                                                                                      displayType={"text"}
                                                                                                      value={parseInt(
                                                                                                          (parseInt(
                                                                                                              row["fieldinsurance_commission"]
                                                                                                              ) *
                                                                                                              (parseInt(
                                                                                                                  row["requst_ready_end_price"]
                                                                                                                  ) -
                                                                                                                  parseInt(
                                                                                                                      row["requst_ready_code_penalty"]
                                                                                                                  )) *
                                                                                                              100) /
                                                                                                          109 /
                                                                                                          100
                                                                                                      )}
                                                                                                      thousandSeparator={true}
                                                                                                      prefix={" ریال"}
                                                                                                  />
                                                                                            }
                                                                                      </TableCell>


                                                                                      <TableCell key={"user_pey_cash"} align={"center"}>
                                                                                            {
                                                                                                  <NumberFormat
                                                                                                      displayType={"text"}
                                                                                                      value={parseInt(
                                                                                                          (parseInt(
                                                                                                              row["fieldinsurance_commission"]
                                                                                                              ) *
                                                                                                              (parseInt(row["user_pey_cash"]) +
                                                                                                                  parseInt(
                                                                                                                      row["user_pey_instalment_pass"]
                                                                                                                  ) -
                                                                                                                  parseInt(
                                                                                                                      row["requst_ready_code_penalty"]
                                                                                                                  )) *
                                                                                                              100) /
                                                                                                          109 /
                                                                                                          100
                                                                                                      )}
                                                                                                      thousandSeparator={true}
                                                                                                      prefix={" ریال"}
                                                                                                  />
                                                                                            }
                                                                                      </TableCell>

                                                                                      <TableCell
                                                                                          key={"peysumcommision"}
                                                                                          align={"center"}
                                                                                      >
                                                                                            {
                                                                                                  <NumberFormat
                                                                                                      displayType={"text"}
                                                                                                      value={row["peysumcommision"]}
                                                                                                      thousandSeparator={true}
                                                                                                      prefix={" ریال"}
                                                                                                  />
                                                                                            }
                                                                                      </TableCell>

                                                                                      <TableCell
                                                                                          key={"peycommision_marketer"}
                                                                                          align={"center"}
                                                                                      >
                                                                                            {
                                                                                                  <NumberFormat
                                                                                                      displayType={"text"}
                                                                                                      value={row["peycommision_marketer"]}
                                                                                                      thousandSeparator={true}
                                                                                                      prefix={" ریال"}
                                                                                                  />
                                                                                            }
                                                                                      </TableCell>

                                                                                      <TableCell
                                                                                          key={"peycommision_marketer_id"}
                                                                                          align={"center"}
                                                                                      >
                                                                                            {row["peycommision_marketer"] !== 0
                                                                                                ? row["peycommision_marketer_name"] +
                                                                                                " " +
                                                                                                row["peycommision_marketer_family"] +
                                                                                                " -همراه : " +
                                                                                                row["peycommision_marketer_id"] +
                                                                                                "شماره همراه : " +
                                                                                                row["peycommision_marketer_mobile"]
                                                                                                : ""}
                                                                                      </TableCell>

                                                                                      <TableCell
                                                                                          key={"peycommision_leader"}
                                                                                          align={"center"}
                                                                                      >
                                                                                            {
                                                                                                  <NumberFormat
                                                                                                      displayType={"text"}
                                                                                                      value={row["peycommision_leader"]}
                                                                                                      thousandSeparator={true}
                                                                                                      prefix={" ریال"}
                                                                                                  />
                                                                                            }
                                                                                      </TableCell>

                                                                                      <TableCell
                                                                                          key={"peycommision_leader_id"}
                                                                                          align={"center"}
                                                                                      >
                                                                                            {row["peycommision_leader"] !== 0
                                                                                                ? row["peycommision_leader_name"] +
                                                                                                " " +
                                                                                                row["peycommision_leader_family"] +
                                                                                                " - کد : " +
                                                                                                row["peycommision_leader_id"] +
                                                                                                "شماره همراه : " +
                                                                                                row["peycommision_leader_mobile"]
                                                                                                : ""}
                                                                                      </TableCell>


                                                                                      <TableCell>
                                                                                            {
                                                                                                  <Button
                                                                                                      variant="contained"
                                                                                                      color="primary"
                                                                                                      onClick={(e) => {
                                                                                                            this.handleSelectRows(e, row);
                                                                                                      }}
                                                                                                  >
                                                                                                        جزئیات
                                                                                                  </Button>
                                                                                            }
                                                                                      </TableCell>
                                                                                </TableRow>
                                                                            );
                                                                      })}
                                                                </TableBody>
                                                          </Table>
                                                    </TableContainer>
                                                    <TablePagination
                                                        rowsPerPageOptions={[
                                                              10, 25, 100, 500, 700, 1000, 5000, 10000, 100000,
                                                        ]}
                                                        component="div"
                                                        count={arrCount}
                                                        rowsPerPage={rowsPerPage}
                                                        page={page}
                                                        onChangePage={this.handleChangePage}
                                                        onChangeRowsPerPage={this.handleChangeRowsPerPage}
                                                    />
                                              </Paper>
                                        </Container>

                                        {this.state.openImageBox && (
                                            <Lightbox
                                                medium={urlToLargeImageFile}
                                                large={urlToHugeImageFile}
                                                alt={descImageFile}
                                                onClose={this.closeLightbox}
                                                showRotate={true}
                                                hideZoom={false}
                                            />
                                        )}
                                  </Grid>
                            </Grid>

                            <Snackbar
                                anchorOrigin={{ vertical: "bottom", horizontal: "left" }}
                                onClose={this.handleClickcloseTasckBar}
                                open={showSnack}
                                autoHideDuration={10000}
                            >
                                  <Alert severity={snackMode}>{snackstr}</Alert>
                            </Snackbar>
                      </div>
                  );
            }
      }
}

export default withStyles(styles)(ChangeReportReferralRequest);
